import { useEffect } from 'react'
import './QNA.css'
import { useQuery } from 'hooks/useQuery'
import { useTranslation } from 'react-i18next'
import { Button } from 'wiz-front-shared/components/button/Button'
import { Spacer } from 'wiz-front-shared/components/Spacer'
import { useAtomValue } from 'jotai'
import { deviceAtom } from 'store/deviceStore'
import { accessTokenAtom } from 'store/tokenStore'
import { qnaStore } from 'store/qnaStore'
import { QNA as QnaTypes } from 'repository/types/QNA.types'
import { Header } from 'components/common/header/Header'
import { getServiceId, getLocale } from 'common/service'

const formatDate = (dateString: string, t: (key: string, options?: any) => string): string => {
    const date = new Date(dateString)
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    return t('qna.dateFormat', { year, month, day })
}

export const QNA = () => {
    const { navigate } = useQuery()
    const { t } = useTranslation()
    const device = useAtomValue(deviceAtom)
    const accessToken = useAtomValue(accessTokenAtom)
    const serviceId = getServiceId()
    const locale = getLocale()
    const qnaListState = useAtomValue(qnaStore.qnaList.stateAtom)
    const rawList = qnaListState?.data?.data?.list
        || qnaListState?.data?.list
        || qnaListState?.data?.data
        || qnaListState?.data
        || []
    const qnaList: QnaTypes.QnaItem[] = Array.isArray(rawList)
        ? rawList.map((item: any) => ({
            qnaNo: Number(item.qnaNo ?? item.qna_id ?? 0),
            title: item.title ?? '',
            content: item.content ?? '',
            answer: item.answer ?? null,
            status: item.status === 'ANSWERED' || item.status === 'answer' || item.status === 'COMPLETE' ? 'ANSWERED' : 'WAIT',
            categoryCode: item.categoryCode ?? 'ETC',
            regTime: item.regTime ?? item.regDt ?? item.reg_date ?? '',
            answerTime: item.answerTime ?? null,
        }))
        : []
    const inset = device.inset

    useEffect(() => {
        if (accessToken) {
            qnaStore.getQnaList({ serviceId, locale, pageNo: 1, pageSize: 20 })
        }
    }, [accessToken])

    const handleItemClick = (item: QnaTypes.QnaItem) => {
        navigate(`/qna/detail?qnaNo=${item.qnaNo}`)
    }

    const handleSubmit = () => {
        // TODO: navigate to submit page
        navigate('/qna/send')
    }

    return (
        <div className="qna-wrapper">
            <Header title={t('qna.myQuestion')} isBack />

            <div className="qna-list">
                {!accessToken && <div className="qna-status">{t('qna.list.needLogin')}</div>}
                {accessToken && qnaListState.isPending && <div className="qna-status">{t('qna.list.loading')}</div>}
                {accessToken && qnaListState.isError && <div className="qna-status">{t('qna.list.error')}</div>}
                {accessToken && qnaListState.isReady && qnaList.length === 0 && <div className="qna-status">{t('qna.list.empty')}</div>}

                {accessToken && qnaListState.isReady && qnaList.map((item) => (
                    <div
                        key={item.qnaNo}
                        className={`qna-card ${item.status === 'ANSWERED' ? 'qna-card-answered' : ''}`}
                        onClick={() => handleItemClick(item)}
                    >
                        <div className="qna-card-header">
                            <span className={`qna-badge ${item.status === 'ANSWERED' ? 'qna-badge-answered' : 'qna-badge-pending'}`}>
                                {item.status === 'ANSWERED' ? t('qna.answered') : t('qna.pending')}
                            </span>
                            <span className="qna-date">{formatDate(item.regTime, t)}</span>
                        </div>
                        <span className="qna-category">[ {t(`qna.category.${item.categoryCode}`)} ]</span>
                        <span className="qna-title">{item.title}</span>
                    </div>
                ))}
            </div>

            {accessToken && (
                <div className="qna-submit-wrapper" style={{ paddingBottom: inset.navigationBarHeight }}>
                    <Button text={t('qna.submit')} onPress={handleSubmit} />
                    <Spacer height={10} />
                </div>
            )}
        </div>
    )
}
